/**
 * Название месяца в узбекской дате, к которой слитно приклеено окончание
 * («25-noyabr» + «gacha», «25-ноябрь» + «гача»).
 *
 * Дата в сообщении — подстановка `{date}`, а окончание — литерал рядом:
 * `{date}gacha`, `{date}dan`, `{date}da`, `{date}ga`. Поэтому месяц в дате
 * узбекского обязан быть ПОЛНЫМ (`units.month.inDate`): с сокращением выходило
 * «25-noygacha» / «25-нойгача» — слово, которого нет.
 *
 * В кириллице у такой даты есть вторая сторона. Транслитератор пишет
 * самостоятельное название месяца с мягким знаком («ноябрь», как принято в
 * `translit.ts`), и знак остаётся у подставленной даты: «25-ноябрь» + «гача» =
 * «25-ноябрьгача». Перед окончанием ь не пишется («25-ноябргача», «30-октябрда»);
 * в литералах каталога это решает `translit.ts`, а подстановку, которой при
 * сборке каталога ещё нет, чинит `dropMonthSign` при показе.
 *
 * Модуль без зависимостей: его читают и приложение, и скрипты, и тесты.
 */

/** Основы кириллических названий, у которых в самостоятельной форме есть ь. Май, март и август знака не имеют. */
const SIGN_STEMS = ['январ', 'феврал', 'апрел', 'июн', 'июл', 'сентябр', 'октябр', 'ноябр', 'декабр'] as const;

const LETTER = 'а-яёўқғҳ';
const AFTER_SIGN = new RegExp(`(?<![${LETTER}])(${SIGN_STEMS.join('|')})ь(?=[${LETTER}])`, 'giu');

/**
 * Убрать мягкий знак у названия месяца, за которым без пробела идёт буква
 * (окончание): «25-ноябрьгача» → «25-ноябргача». Самостоятельное название
 * («25-ноябрь», «ноябрь, 2026») и любые другие слова с ь («компьютер», «фильм»)
 * не меняются.
 */
export function dropMonthSign(text: string): string {
  return text.includes('ь') || text.includes('Ь') ? text.replace(AFTER_SIGN, '$1') : text;
}
